import React, { useEffect, useMemo, useState } from 'react'
import { MediaCategory, MediaWithCategories } from '../../../../types/Media'
import cx from 'classnames'
import styles from './MediaList.module.css'
import Loader from '../../../../components/Loader'
import CreateMediaCard from '../CreateMediaCard/CreateMediaCard'
import MediaCard from '../MediaCard/MediaCard'
import { useFetchData } from '../../../../hooks/useFetchData'
import { ApiRoutes } from '../../../../services/ApiService'
import CategoryFilter from '../CategoryFilter/CategoryFilter'

const MediaList: React.FC = () => {
    const {
        data: media,
        fetch: fetchMedia,
        isLoading: isMediaLoading,
    } = useFetchData<MediaWithCategories>(ApiRoutes.MEDIA)

    const { data: categories, fetch: fetchCategories } =
        useFetchData<MediaCategory>(ApiRoutes.MEDIA_CATEGORIES)

    const [selectedCategoryIds, setSelectedCategoryIds] = useState<number[]>([])

    useEffect(() => {
        fetchMedia()
    }, [fetchMedia])

    useEffect(() => {
        fetchCategories()
    }, [fetchCategories])

    const refetch = () => {
        fetchMedia()
        fetchCategories()
    }

    const filteredMedia: MediaWithCategories[] = useMemo(() => {
        return selectedCategoryIds.length > 0
            ? media.filter((mediaElement) => {
                  return mediaElement.media_category_ids.some((cat_id) => {
                      return selectedCategoryIds.includes(cat_id)
                  })
              })
            : media
    }, [media, selectedCategoryIds])

    return (
        <>
            <CategoryFilter
                categories={categories}
                onChange={(ids: number[]) => setSelectedCategoryIds(ids)}
            />
            {!isMediaLoading && (
                <div className={cx(styles['media-list'])}>
                    <CreateMediaCard onCreate={() => refetch()} />
                    {filteredMedia.map((mediaElement) => {
                        return (
                            <MediaCard
                                key={mediaElement.id}
                                media={mediaElement}
                                onEdit={() => refetch()}
                                onDelete={() => refetch()}
                                categories={categories}
                            />
                        )
                    })}
                </div>
            )}
            {isMediaLoading && (
                <div className={cx(styles['loading-wrapper'])}>
                    <Loader isLoading={isMediaLoading} size={'m'} />
                </div>
            )}
        </>
    )
}

export default MediaList
